import { R } from '@/features/booking/resources/Texts.resx';
import { Button, Card, RadioButton, VerticalContainer } from '@/components';
import {
    bookingDraftAtom,
    bookingErrorAtom,
    updateDraftAtom,
} from '@/features/booking/shared/model/bookingState';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { ProductDto } from '@/shared/interfaces';

type SelectCategoryProps = {
    product: ProductDto;
    onSubmit: () => void;
};

export const SelectCategory = ({ product, onSubmit }: SelectCategoryProps) => {
    const categories = product.AvailableCategories?.Categories;
    if (!categories.length) return;

    const [_, setErrorMessage] = useAtom(bookingErrorAtom);
    const draftState = useAtomValue(bookingDraftAtom);
    const updateSessionState = useSetAtom(updateDraftAtom);

    const handleSubmit = () => {
        if (
            !draftState?.category &&
            product.AvailableCategories?.CategoryRequiredMessage
        ) {
            setErrorMessage(
                product.AvailableCategories.CategoryRequiredMessage,
            );
            return;
        }
        onSubmit();
    };

    return (
        <Card alwaysCard={false} usePadding={false}>
            <div>
                <h2 className="ns:px-6 p-6 px-2">
                    {product.AvailableCategories.SelectCategoryTitle}
                </h2>

                <VerticalContainer className="w-full" spacing="none">
                    {categories.map((category) => {
                        return (
                            <RadioButton
                                id={category.Id}
                                className="h-6 w-6"
                                onChange={() =>
                                    updateSessionState({
                                        category: category.Id,
                                    })
                                }
                                name={category.Id}
                                checked={draftState?.category === category.Id}
                                value="true"
                                label={category.Text}
                                containerClassName="ns:px-6 px-2 py-4 hover:bg-gray-100 focus:outline-none"
                                key={category.Id}
                            />
                        );
                    })}
                </VerticalContainer>

                <div className="ns:p-6 flex w-full flex-row justify-end pt-4">
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        className="ns:w-auto mt-2 w-full min-w-44"
                    >
                        {R.Next}
                    </Button>
                </div>
            </div>
        </Card>
    );
};
